import { useCallback, useMemo, useState } from "react";
import { GeoJSON, Marker, Pane, Polyline, Tooltip } from "react-leaflet";
import { divIcon, icon, MarkerCluster, point } from "leaflet";

import { Box, Card, Stack, Typography } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { renderToStaticMarkup } from "react-dom/server";

import MarkerClusterGroup from "react-leaflet-cluster";
import useEvenets from "Hooks/useEvenets";
import { EVENTS_TYPES } from "Constants/traffic";

const ICON_SIZE = 22;

export default function EventMarkerCluster() {
  const dispatch = useAppDispatch();
  const { visible } = useAppSelector((state) => state.event);
  const { zone } = useAppSelector((state) => state.zones);
  const { survayLayer } = useAppSelector((state) => state.layers);

  const { data } = useEvenets();

  const eventMarkers = useMemo(() => {
    return data?.map((item: any) => {
      if (!item.Incidents) return;
      const event = JSON.parse(`{${item.Incidents}}`);
      const eventData = EVENTS_TYPES.filter((c) => c.type === event.Type)[0];

      const eventIconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: "35px",
            height: "35px",
            backgroundColor: "#fffd",
            borderRadius: "50%",
            border: "2px solid",
            borderColor: "#62b362cc",
            display: "grid",
            placeItems: "center",
            color: "#666",
          }}
        >
          <img src={eventData?.imgSrc} alt="test" style={{ width: "28px" }} />
        </Box>
      );

      const eventIcon = divIcon({
        html: eventIconMarkup,
        iconSize: [ICON_SIZE, ICON_SIZE],
        iconAnchor: [18, 30],
      });

      const tooltipContent = (
        <Tooltip direction="top" offset={[0, -20]}>
          <Card sx={{ py: 2, px: 3 }}>
            <Stack alignItems="flex-end">
              <Typography> نوع موقعیت: {event.Location_Type}</Typography>
              <Typography> نوع حادثه : {event.Type}</Typography>
              <Typography> منطقه : {event.Zone_Name}</Typography>
              <Typography>موقعیت مکانی : {event.Location_Name}</Typography>
            </Stack>
          </Card>
        </Tooltip>
      );

      return (
        <>
          <Marker key={`event-${event.ID}`} position={[event.long, event.lat]} icon={eventIcon}>
            {tooltipContent}
          </Marker>
        </>
      );
    });
  }, [data, visible]);

  const handleSetSourceClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small source-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium source-m";
    }
    return "marker-cluster marker-cluster-large source-l";
  };

  const createSourceCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetSourceClass(cluster.getChildCount()),
      iconSize: point(40, 40, true),
    });
  }, []);

  if (!visible) return <></>;
  return (
    <>
      <Pane name={`${Math.random()}show_event_marker`} style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        <MarkerClusterGroup chunkedLoading maxClusterRadius={50} iconCreateFunction={createSourceCustomIcon}>
          {eventMarkers}
        </MarkerClusterGroup>
      </Pane>
    </>
  );
}
